import React, { useState, useEffect, useContext } from "react"
import { useStaticQuery, graphql } from "gatsby"
import ReactHtmlParser, { processNodes } from "react-html-parser"
import PropTypes from "prop-types"
import Parser from "rss-parser"
import TransitionFade from "../transition-fade"
import {
  RssCategories,
  RssContent,
  RssTitle,
} from "./RssParser/rss-parser-styled"
import { ContentContainer } from "./content-transformer-styled"
import {
  rssTitle,
  rssImage,
  rssContent,
  rssCategories,
} from "./RssParser/rss-parser.module.scss"
import CarouselTransformer from "./CarouselTransformer/carousel-transformer"
import GalleryTransformer from "./GalleryTransformer/gallery-transformer"
import { RenderFontAwesome } from "./render-font-awesome"
import InnerHTML from "dangerously-set-html-content"
import { NotificationContext } from "gatsby-theme-blank/src/components/notification-context"
import Icon from "gatsby-theme-blank/src/components/Icon/icon"
import { useBuildData } from "gatsby-theme-blank/src/hooks/use-build-data"
import { LightBoxImage } from "../LightBoxImage/light-box-image"
const parser = new Parser({
  customFields: {
    item: [["media:content", "itemImg"]],
  },
})

const containerAlign = {
  left: { float: "left" },
  right: { float: "right" },
}

function domain_from_url(url) {
  let result
  let match
  if (match = url.match(/^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n\?\=]+)/im)) { // eslint-disable-line
    result = match[1]
      if (match = result.match(/^[^\.]+\.(.+\..+)$/)) { // eslint-disable-line
      result = match[1]
    }
  }
  return result
}

function check_parent_is_link(node) {
  if (node.name === "a") {
    return true
  } else if (node.parent === null) {
    return false
  }
  return check_parent_is_link(node.parent)
}

const ContentTransformer = ({ content }) => {
  const [rssFeed, setRssFeed] = useState("")
  const setRssFeedFinal = (element) => {
    setRssFeed(element)
  }
  const { setIsOpen } = useContext(NotificationContext)
  const [transformedContent, setTransformedContent] = useState()
  const data = useStaticQuery(graphql`
    query {
      allFileFile {
        edges {
          node {
            localFile {
              SlugifiedPublicUrl
              extension
              base
            }
            drupal_id
            uri {
              url
            }
          }
        }
      }
    }
  `)
  const { allFileFile } = data
  const themeColors = useBuildData().theme_settings.palette
  const options = {
    buttons: {
      backgroundColor: themeColors.b_color_gradients.b_dark,
      showAutoplayButton: false,
      showCloseButton: true,
      showDownloadButton: false,
      showFullscreenButton: true,
      showNextButton: false,
      showPrevButton: false,
      showThumbnailsButton: false,
    },
  }
  useEffect(() => {
    setTransformedContent(
      contentParser(
        content,
        allFileFile,
        setRssFeedFinal,
        rssFeed,
        setIsOpen,
        options
      )
    )
  }, [allFileFile, content, rssFeed])
  return <ContentContainer>{transformedContent}</ContentContainer>
}

const contentParser = (
  content,
  allFiles,
  setRssFeedFinal,
  rssFeed,
  setIsOpen,
  options
) => {
  return new ReactHtmlParser(content, {
    transform: function transform(node, elementIndex) {
      // text parser
      if (node.type === "text" && node.parent?.name === undefined) {
        return <p>{node.data}</p>
      }
      // img parser
      if (node.type === "tag" && node.name === "figure") {
        const properties = {}
        // align
        const tabClass = node.attribs.class
        const tabClassSplitted = tabClass?.split(" ")
        properties.padding = "1rem"
        if (tabClassSplitted) {
          tabClassSplitted.map((element) => {
            if (element === "align-right") {
              properties.float = "right"
            } else if (element === "align-left") {
              properties.float = "left"
            } else if (element === "align-center") {
              properties.marginLeft = "auto"
              properties.marginRight = "auto"
              properties.float = "none"
              properties.display = "flex"
              properties.flexDirection = "column"
              properties.alignItems = "center"
            }
            return null
          })
        }
        return (
          <figure key={elementIndex} style={properties} role="group">
            {processNodes(node.children, transform)}
          </figure>
        )
      }
      if (
        node.type === "tag" &&
        node.name === "ul" &&
        (node.attribs.class === "carouselContainer" ||
          node.attribs.class === "galleryContainer" ||
          (node.parent?.name === "div" &&
            (node.parent?.attribs.class === "carouselContainer" ||
              node.parent?.attribs.class === "galleryContainer")))
      ) {
        const allImages = node.children
          .map((element) => {
            // On s'assure de sélectionner l'image et non le potentiel
            // texte invisible entre les balises
            if (
              element?.name === "li" &&
              (element.children[0]?.name === "img" ||
                element.children[1]?.name === "img" ||
                element.children[0]?.name === "figure" ||
                element.children[1]?.name === "figure")
            ) {
              return element.children[0].name === "img" ||
                element.children[0].name === "figure"
                ? element.children[0]
                : element.children[1]
            } else if (
              element?.name === "li" &&
              (element.children[0]?.name === "a" ||
                element.children[1]?.name === "a")
            ) {
              return element.children[0].name === "a"
                ? element.children[0]
                : element.children[1]
            }
            return undefined
          })
          .filter((item) => item)
          .map((element) => {
            delete element.attribs.width
            delete element.attribs.height
            return element
          })
        if (
          allImages &&
          (node.parent?.attribs.class === "carouselContainer" ||
            node.attribs.class === "carouselContainer")
        ) {
          let type = "default"
          if (node.parent?.attribs["data-type"] || node.attribs["data-type"]) {
            type =
              node.parent?.attribs["data-type"] || node.attribs["data-type"]
          }
          return (
            <CarouselTransformer
              key={elementIndex}
              html={processNodes(allImages, transform)}
              type={type}
            />
          )
        } else if (
          allImages &&
          (node.parent?.attribs.class === "galleryContainer" ||
            node.attribs.class === "galleryContainer")
        ) {
          return (
            <GalleryTransformer
              key={elementIndex}
              html={processNodes(allImages, transform)}
            />
          )
        }
        return null
      }

      if (node.type === "tag" && node.name === "img") {
        const properties = {}
        const uuid = node.attribs["data-entity-uuid"]
        const width = node.attribs.width
        const alt = node.attribs.alt || ""
        // align
        const tabClass = node.attribs.class
        const tabClassSplitted = tabClass?.split(" ")
        if (node.parent?.name !== "figure") {
          properties.marginRight = "auto"
          properties.marginLeft = "0"
          properties.marginBottom = "0.5rem"
          properties.padding = "1rem"
          properties.display = "block"
        } else {
          properties.marginRight = "inherit"
          properties.marginLeft = "inherit"
          properties.display = "block"
          properties.marginBottom = "0.5rem"
        }
        if (width) {
          properties.width = width + "px"
        }
        if (tabClassSplitted) {
          tabClassSplitted.map((element) => {
            if (element === "align-right") {
              properties.marginLeft = "auto"
              properties.marginRight = "0"
              properties.float = "right"
            } else if (element === "align-left") {
              properties.marginLeft = "0"
              properties.marginRight = "auto"
              properties.float = "left"
            } else if (element === "align-center") {
              properties.marginLeft = "auto"
              properties.marginRight = "auto"
              properties.float = "none"
            }
            return null
          })
        }
        // style
        // Convert string style into object properties
        const style = node.attribs.style
        const dataAlign = node.attribs["data-align"]
        let containerStyle = null
        if (dataAlign !== undefined) {
          if (dataAlign === "center") {
            properties.marginLeft = "auto"
          }
          containerStyle = containerAlign[dataAlign]
        } else {
          let alignClass = node.attribs.class
          if (alignClass !== undefined && alignClass.includes("align-")) {
            alignClass = alignClass.replace("align-", "")
            if (alignClass === "center") {
              properties.marginLeft = "auto"
            }
            containerStyle = containerAlign[alignClass]
          }
        }

        if (style) {
          const regex = /([\w-]*)\s*:\s*([^;]*)/g
          let match
          while ((match = regex.exec(style))) {
            properties[match[1]] = match[2].trim()
          }
        }
        if (uuid) {
          // internal images
          for (let index = 0; index < allFiles.edges.length; index++) {
            if (
              allFiles.edges[index].node.drupal_id === uuid &&
              allFiles.edges[index].node.localFile
            ) {
              if (!check_parent_is_link(node)) {
                return (
                  <LightBoxImage
                    key={elementIndex}
                    type={"node"}
                    node={{
                      alt: alt,
                      file: allFiles.edges[index].node.localFile,
                      style: properties,
                      containerStyle: containerStyle,
                    }}
                  />
                )
              }
              return (
                <img
                  key={elementIndex}
                  style={properties}
                  alt={alt}
                  src={allFiles.edges[index].node.localFile.SlugifiedPublicUrl}
                />
              )

              // const imgSharp = allFiles.edges[index].node.localFile
              // if (imgSharp.childImageSharp) {
              //   if (!width) {
              //     width = imgSharp.childImageSharp?.fluid.presentationWidth
              //   }
              //   if (!height) {
              //     height = imgSharp.childImageSharp?.fluid.presentationHeight
              //   }
              //   imgSharp.childImageSharp.fluid.presentationWidth = width + "px"
              //   imgSharp.childImageSharp.fluid.presentationHeight =
              //     height + "px"
              //   imgSharp.childImageSharp.alt = alt
              //   imgSharp.childImageSharp.style = properties
              // }
              // return <NonStretchedImage {...imgSharp} />
            }
          }
        } else {
          // external images
          const src = node.attribs.src
          if (src) {
            if (!check_parent_is_link(node)) {
              return (
                <LightBoxImage
                  type={"node"}
                  node={{
                    alt: alt,
                    src: src,
                    style: properties,
                    containerStyle: containerStyle,
                  }}
                />
              )
            }
            ;<img src={src} alt={alt} style={properties} />
          }
        }
      }

      // Avoid rendering automatically added p tag for tabs template

      if (
        node.type === "tag" &&
        node.name === "p" &&
        node.parent?.name === "div" &&
        node.attribs?.class === undefined
      ) {
        if (node.children[0].next !== null) {
          return processNodes(node.children, transform)
        }
      }

      // Link parser
      else if (node.type === "tag" && node.name === "a") {
        const href = node.attribs.href
        if (href !== undefined) {
          if (href[0] === "#") {
            node.attribs.target = "_self"
          } else {
            node.attribs.target = "_blank"
          }
        }

        node.attribs.rel = "noopener noreferrer"
        const nodeContent = node.children[0].data
        const drupalIdRegex = /sites\/([^/]+)\/files/g

        if (href) {
          const ext = href.substr(href.lastIndexOf(".") + 1)
          if (href.indexOf("/") === 0 && !drupalIdRegex.test(href)) {
            // manage internal links
            return (
              <TransitionFade
                key={elementIndex}
                link={href}
                className={node.attribs.class}
              >
                {processNodes(node.children, transform)}
              </TransitionFade>
            )
          }
          const attributes = ext === "pdf" ? "" : "download"
          for (let index = 0; index < allFiles.edges.length; index++) {
            const file = allFiles.edges[index].node
            if (
              decodeURIComponent(file.uri.url) === decodeURIComponent(href) &&
              file.localFile
            ) {
              // Check if localFile exists -> optional verification to avoid potential "cannot read publicUrl of null" error
              /*
                Link component cannot be used in this use case beacuse it has onClick handler that overrides any default functionality of the anchor element.
                */
              return (
                <a
                  rel="noopener noreferrer"
                  target={ext === "pdf" ? "_blank" : "_self"}
                  key={file.drupal_id}
                  href={file.localFile.SlugifiedPublicUrl}
                  className={node.attribs.class}
                  {...attributes}
                >
                  {processNodes(node.children, transform)}
                </a>
              )
            }
          }
          // Rss parser if links contains RSS-
          if (nodeContent?.toLowerCase().includes("rss-")) {
            // nodeContent can be undefined if <a> tag have nested children
            ;(async function getFeed() {
              const siteName =
                domain_from_url(href).split(".")[0] + new URL(href).pathname
              const feed = await parser.parseURL(
                "https://" + process.env.GATSBY_FLUX_RSS_PROXY + "/" + siteName
              )
              if (!rssFeed[href]) {
                const rssFeedFinal = { ...rssFeed }
                rssFeedFinal[href] = feed
                setRssFeedFinal(rssFeedFinal)
              }
            })()
            if (rssFeed[href]) {
              return (
                <div key={rssFeed[href].title}>
                  <RssTitle className={rssTitle} href={rssFeed[href].link}>
                    <h3>{rssFeed[href].title}</h3>
                  </RssTitle>
                  {rssFeed[href].description?.indexOf("https://") === -1 && (
                    <p>{rssFeed[href].description}</p>
                  )}
                  {rssFeed[href].image?.url && (
                    <div className={rssImage}>
                      <img
                        alt="imgRss"
                        src={rssFeed[href].image.url}
                        aria-hidden={true}
                      />
                    </div>
                  )}
                  <RssContent className={rssContent}>
                    {rssFeed[href].items.map((item) => (
                      <li key={item.title}>
                        <div>
                          {item.enclosure && (
                            <img
                              alt="imgRss"
                              src={item.enclosure.url}
                              aria-hidden={true}
                            />
                          )}
                          {item.itemImg?.["media:credit"] && (
                            <figure role={"figure"}>
                              <img
                                alt={item.itemImg["media:credit"][0]._}
                                src={item.itemImg.$.url}
                                aria-hidden={true}
                              />
                              <figcaption>
                                {item.itemImg["media:credit"][0]._}
                              </figcaption>
                            </figure>
                          )}
                          <div>
                            <RssCategories className={rssCategories}>
                              {item.categories
                                ?.slice(0, 6)
                                .map((category, index) => (
                                  <li key={`${category._}${index}`}>
                                    <a
                                      key={`${category._}${index}`}
                                      href={
                                        category.$ ? category.$.domain : href
                                      }
                                    >
                                      {category._ ? category._ : category}
                                    </a>
                                  </li>
                                ))}
                            </RssCategories>
                          </div>
                        </div>
                        <a href={item.link}>
                          <h4>{item.title}</h4>
                          <p>{item.contentSnippet}</p>
                        </a>
                      </li>
                    ))}
                  </RssContent>
                </div>
              )
            }
          }

          // Webpush button if links contains BOUTON-NOTIFICATION
          if (nodeContent?.toLowerCase().includes("bouton-notification")) {
            return (
              <button
                aria-label="Gestion des notifications"
                className="btn"
                onClick={() => setIsOpen(true)}
              >
                <Icon icon="bell" size={16}></Icon>
              </button>
            )
          }
        }
      } else if (
        (node.type === "tag" && node.name === "i") ||
        (node.type === "tag" && node.name === "span")
      ) {
        return RenderFontAwesome(node, transform)
      } else if (node.type === "script" && node.name === "script") {
        if (
          node.attribs.src?.includes("synbird") ||
          node.attribs.src?.includes("intramuros") ||
          node.attribs.src?.includes("tourinsoft")
        ) {
          const html = `<script async defer src='${node.attribs.src}'></script>`
          return <InnerHTML key={elementIndex} html={html} />
        } else if (node.children[0]?.data?.includes("intramuros")) {
          const html = `<script>${node.children[0].data}</script>`
          return <InnerHTML key={elementIndex} html={html} />
        }
        const html = `<script>${node.children[0]?.data}</script>`
        return <InnerHTML key={elementIndex} html={html} />
      }
    },
  })
}

//-----------------------Prop-Types---------------------------//

ContentTransformer.propTypes = {
  content: PropTypes.node,
}
contentParser.propTypes = {
  content: PropTypes.node.isRequired,
  allFiles: PropTypes.node.isRequired,
  setRssFeedFinal: PropTypes.func,
  rssFeed: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  options: PropTypes.object.isRequired,
}

//-----------------------Prop-Types---------------------------//

export default ContentTransformer
